import { runListenersForEvent as chatMessageReceivedHelpers } from 'core_main/globals/events';
import { ON_MESSAGE_RECEIVED_EVENT_TYPE } from 'core/constants';
import { createMessageCallbackResponse } from 'core_main/sdk/send_message/helpers';
import {
  ChatMessagesData,
  GetChatMessageAttachmentsData,
} from 'core_main/api/messages/types';
import { incrementUnreadCountInStore } from 'core_main/store';

import { runListenersForOnUnreadCountChangeEvent } from 'core_main/sdk/mark_read/helpers';
import { Included } from '../types';

export const runListenersForOnMessageReceivedEvent = (
  message: ChatMessagesData,
  attachmentData?: GetChatMessageAttachmentsData[],
  includedData?: Included[],
  shouldIncrementUnreadCount = true,
) => {
  const messageCallbackResponse = createMessageCallbackResponse(
    message,
    attachmentData,
    includedData,
  );

  const sessionId = message.relationships.session.data.id;

  if (shouldIncrementUnreadCount) {
    incrementUnreadCountInStore(sessionId);
    runListenersForOnUnreadCountChangeEvent(sessionId);
  }

  chatMessageReceivedHelpers(
    ON_MESSAGE_RECEIVED_EVENT_TYPE,
    messageCallbackResponse,
  );
};
